<dialog-draggable-header>Authorities</dialog-draggable-header>

<div mat-dialog-content class="dialog-content-height">
   <data-table #authorityTable [data]="authorities" [columns]="columns" [loading]="loading" (select)="onAuthoritySelect($event)"
      [paging]="true" [pageSize]="pageOptions.size" (lazyLoad)="onLazyLoad($event)" [lazy]="true"
      [lazyLoadOnInit]="false" [totalRecords]="total" (edit)="updateAuthorityChange($event)" [filterColumnDisplay]="false">
      <ng-container actionStart>
         <div *ngIf="this.data.selected && this.data.selected?.partNumber">
            <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
            <span><strong>Part #: </strong>{{ data.selected.partNumber }}</span>
            <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
            <span><strong>File Type: </strong> {{ !(data.selected.fileType) ? '(None)' : data.selected.fileType }}</span>
            <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
            <span><strong>Release Level:
               </strong>{{ !(data.selected.releaseLevel) ? '(None)' : data.selected.releaseLevel }}</span>
            <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
         </div>
         <button mat-button (click)="onAddAuthorityClick()" (keypress.enter)="onAddAuthorityClick()"
            *ngIf="!this.resourced && data.selected.partNumber === null">
            Add Authority</button>
             <button mat-button [disabled] = "!hasSelectedSingle" (click)="onEditAuthorityClick()" (keypress.enter)="onEditAuthorityClick()"
            *ngIf="!this.resourced && data.selected.partNumber === null">
            Edit Authority</button>
         <button mat-button *ngIf="this.resourced && data.selected.partNumber === null" [disabled]="true">
            Add Authority</button>
         <button mat-button [disabled] = "!hasSelectedSingle" (click)="onDeleteClick(selectedAuthority)"
            (keypress.enter)="onDeleteClick(selectedAuthority)"
            *ngIf="!this.resourced && data.selected.partNumber === null">Delete
            Authority</button>
         <button mat-button *ngIf="this.resourced && data.selected.partNumber === null" [disabled]="true">
            Delete Authority</button>
      </ng-container>
      <ng-container actionEnd>
         <button mat-dialog-close mat-button> Close </button>
      </ng-container>
   </data-table>
</div>
